import ConfigService from "@/services/ConfigService";
import {
    VuexModule,
    Module,
    Mutation,
    Action,
    MutationAction,
} from "vuex-module-decorators";
import FormData from 'form-data';
import Vue from "vue";
import Logistica from "../../interfaces/Logistica";
import Financeiro from "../../interfaces/Financeiro";
import store from "..";
import { ComercialGeralConfig, EstoqueConfig } from "../../interfaces/Comercial";
import imageService from "@/services/ImageService";
import { normalizeHttp } from "../../components/utils";

@Module({ namespaced: true })
class ConfigModule extends VuexModule {
    public listaPaginasCustom = [] as Array<any>;
    public configsVisuais = {} as any;
    public linksRedesSociais = {} as any;
    public listaBanners = [] as Array<any>;
    public localizacaoAtual = { lat: 0, lng: 0 }
    public aplicativo = {} as any;

    public configEstoque = {} as any;
    public configLogistica = {} as Logistica;
    public configFinanceiro = {} as Financeiro;
    public configTrocas = {} as any;
    public configComercialGeral = {} as ComercialGeralConfig

    @Action({ rawError: true })
    salvarConfiguracoesVisuais(payload: { visual: any; cores: any; imagemLogo?: any; imagemIcone?: any; tempoTransicaoBanner?: number }): void {
        const formData = new FormData();
        formData.append("nomeLoja", payload.visual?.nomeLoja);
        formData.append("telefone", payload.visual?.fone);
        formData.append("celular", payload.visual?.celular);
        formData.append("corFundo", payload.cores?.fundo || "#D8D8D8");
        formData.append("corPrincipal", payload.cores?.principal || "#333333");
        formData.append("corTexto", payload.cores?.texto || "#333333");
        formData.append("tempoTransicaoBanner", payload.tempoTransicaoBanner?.toString() || "5000");
        if (payload.imagemLogo)
            formData.append("imagemLogo", payload.imagemLogo);
        if (payload.imagemIcone)
            formData.append("imagemIcone", payload.imagemIcone);

        ConfigService.salvarConfigVisual(formData).then(
            resp => {
                if (!resp?.data) return;
                store.dispatch("Notifications/showInfoMessage", "Configurações salvas com sucesso", { root: true });
                this.context.commit('setConfigsVisuais', {
                    visual: {
                        nomeLoja: resp.data.nomeLoja,
                        fone: resp.data.telefone,
                        celular: resp.data.celular
                    },
                    cores: {
                        fundo: resp.data.corFundo,
                        principal: resp.data.corPrincipal,
                        texto: resp.data.corTexto
                    },
                    imagemLogo: resp.data.imagemLogo,
                    tempoTransicaoBanner: resp.data.tempoTransicaoBanner
                });
            },
            err => {
                store.dispatch(
                    "Notifications/showErrorMessage",
                    `Falha ao salvar as configurações! ${err?.response?.status == 401 ? "Não autorizado" : err?.message}`,
                    { root: true }
                );
            }
        )
    }

    @Action({ rawError: true })
    salvarLinksAplicativos(payload: any): void {
        ConfigService.salvarConfigLinksApp(payload).then(
            resp => {
                store.dispatch("Notifications/showInfoMessage", "Configurações salvas com sucesso", { root: true });
                this.context.commit('setAplicativo', payload);
            },
            error => {
                store.dispatch("Notifications/showErrorMessage", "Falha ao salvar as configurações " + error?.response?.data || error.message || error, { root: true });
            }
        )
    }

    @Action({ rawError: true })
    salvarLinksRedesSociais(payload: any): void {
        ConfigService.salvarConfigLinksRedes(payload).then(
            resp => {
                store.dispatch("Notifications/showInfoMessage", "Configurações salvas com sucesso", { root: true });
                this.context.commit('setLinksRedesSociais', payload);
            },
            error => {
                store.dispatch("Notifications/showErrorMessage", "Falha ao salvar as configurações " + error?.response?.data || error.message || error, { root: true });
            }
        )
    }

    @Action({ rawError: true })
    adicionarBanner(payload: any): Promise<any> {
        const formData = new FormData();
        formData.append("nome", payload.nome);
        formData.append("link", payload.link);
        formData.append("situacao", payload.situacao);
        if (payload.imagem)
            formData.append('imagem', payload.imagem);

        if (payload.id) {
            return ConfigService.atualizarConfigBanner(formData, payload.id).then(
                resp => {
                    if (resp) {
                        store.dispatch("Notifications/showInfoMessage", "Banner Atualizado", { root: true });
                        this.context.commit("setListaBanners", { banner: resp.data })
                        return resp;
                    }
                },
                error => {
                    store.dispatch("Notifications/showErrorMessage", "Falha ao salvar as configurações " + error?.response?.data || error.message || error, { root: true });
                }
            )
        }

        return ConfigService.adicionarConfigBanner(formData).then(
            resp => {
                if (resp) {
                    store.dispatch("Notifications/showInfoMessage", "Banner Adicionado", { root: true });
                    this.context.commit("setListaBanners", { banner: resp.data });
                    return resp;
                }
            },
            error => {
                store.dispatch("Notifications/showErrorMessage", "Falha ao salvar as configurações " + error?.response?.data || error.message || error, { root: true });
            }
        )
    }

    @Action
    removerBanner(id: number): Promise<any> {
        return ConfigService.removerBanner(id).then(
            resp => {
                store.dispatch("Notifications/showInfoMessage", "Banner removido", { root: true });
                this.context.commit("handleRemoveBanner", id);
            },
            error => {
                store.dispatch("Notifications/showErrorMessage", "Falha ao remover o banner" + error?.response?.data || error.message || error, { root: true });
            }
        )
    }

    @Action
    adicionarPaginaConteudo(payload: any): Promise<any> {
        if (payload.id) {
            return ConfigService.atualizarConfigPgConteudo(payload, payload.id).then(
                resp => {
                    if (resp) {
                        store.dispatch("Notifications/showInfoMessage", "Página Atualizada", { root: true });
                        this.context.commit("setListaPaginasCustom", { pagina: resp.data });
                    }
                },
                error => {
                    store.dispatch("Notifications/showErrorMessage", "Falha ao salvar as configurações " + error?.response?.data || error.message || error, { root: true });
                }
            )
        }

        return ConfigService.adicionarConfigPgConteudo(payload).then(
            resp => {
                if (resp) {
                    store.dispatch("Notifications/showInfoMessage", "Página Adicionada", { root: true });
                    this.context.commit("setListaPaginasCustom", { pagina: resp.data });
                }
            },
            error => {
                store.dispatch("Notifications/showErrorMessage", "Falha ao salvar as configurações " + error?.response?.data || error.message || error, { root: true });
            }
        )
    }

    @Action
    removerPaginaConteudo(id: number): Promise<any> {
        return ConfigService.removerConfigPgConteudo(id).then(
            resp => {
                store.dispatch("Notifications/showInfoMessage", "Página removida", { root: true });
                this.context.commit("handleRemovePaginaConteudo", id);
            },
            error => {
                store.dispatch("Notifications/showErrorMessage", "Falha ao remover a página" + error?.response?.data || error.message || error, { root: true });
            }
        )
    }

    @Action({ rawError: true })
    carregarConfiguracoesApp() {
        ConfigService.buscarConfiguracoesApp().then(
            resp => {
                const data = resp.data;
                this.context.commit('setConfigEstoque', data?.ConfigEstoque?.[0]);
                this.context.commit('setConfigComercialGeral', data?.ConfigComercial?.[0]);
                this.context.commit('setConfigLogistica', data?.ConfigLogistica?.[0]);
                this.context.commit('setConfigFinanceiro', data?.ConfigFinanceiro?.[0]);
                this.context.commit('setConfigTrocas', data?.ConfigComercial?.[0]);
                this.context.commit('setListaBanners', { banners: data?.ConfigAppBanner });
                this.context.commit('setListaPaginasCustom', { paginas: data?.ConfigAppPaginaConteudo });
                this.context.commit('setLinksRedesSociais', data?.ConfigAppRedeSocial?.[0]);
                this.context.commit('setAplicativo', data?.ConfigAppApps?.[0]);
                this.context.commit('setConfigsVisuais', {
                    visual: {
                        nomeLoja: data?.ConfigAppVisual?.[0]?.nomeLoja,
                        fone: data?.ConfigAppVisual?.[0]?.telefone,
                        celular: data?.ConfigAppVisual?.[0]?.celular
                    },
                    cores: {
                        fundo: data?.ConfigAppVisual?.[0]?.corFundo,
                        principal: data?.ConfigAppVisual?.[0]?.corPrincipal,
                        texto: data?.ConfigAppVisual?.[0]?.corTexto,
                    },
                    imagemLogo: data?.ConfigAppVisual?.[0]?.imagemLogo,
                    tempoTransicaoBanner: data?.ConfigAppVisual?.[0]?.tempoTransicaoBanner
                });
            },
            error => {
                store.dispatch("Notifications/showErrorMessage", "Falha ao carregar as configurações: " + error?.response?.data || error.message || error, { root: true });
            }
        )

    }

    @Mutation
    setLocalizacaoAtual(coordenadas: any) {
        this.localizacaoAtual = { ...coordenadas };
    }

    @Mutation
    setConfigsVisuais(data: any) {
        this.configsVisuais = { ...data };
    }

    @Mutation
    setAplicativo(data: any) {
        this.aplicativo = { ...data };
    }

    @Mutation
    setLinksRedesSociais(data: any) {
        this.linksRedesSociais = { ...data };
    }

    @Mutation
    handleRemoveBanner(id: number) {
        this.listaBanners = this.listaBanners.filter(el => el.id !== id);
    }

    @Mutation
    handleRemovePaginaConteudo(id: number) {
        this.listaPaginasCustom = this.listaPaginasCustom.filter(el => el.id !== id);
    }

    @Mutation
    setListaBanners(data: { banner?: any; banners?: Array<any> }) {
        if (data.banner) {
            const index = this.listaBanners.findIndex(el => el.id === data.banner.id);
            if (index >= 0) {
                Vue.set(this.listaBanners, index, data.banner);
            } else {
                this.listaBanners = [...this.listaBanners, { ...data.banner }]
            }
        } else {
            this.listaBanners = data.banners || [];
        }
    }


    @Mutation
    setListaPaginasCustom(data: { pagina?: any; paginas?: Array<any> }) {
        if (data.pagina) {
            const index = this.listaPaginasCustom.findIndex(el => el.id === data.pagina.id);

            if (index >= 0) {
                Vue.set(this.listaPaginasCustom, index, data.pagina);
            } else {
                this.listaPaginasCustom = [...this.listaPaginasCustom, { ...data.pagina }]
            }

        } else {
            this.listaPaginasCustom = data.paginas || [];
        }
    }



    @Mutation
    setConfigEstoque(data: any) {
        this.configEstoque = { ...data };
    }

    @Mutation
    setConfigLogistica(data: any) {
        this.configLogistica = { ...data };
    }

    @Mutation
    setConfigFinanceiro(data: any) {
        this.configFinanceiro = { ...data };
    }

    @Mutation
    setConfigTrocas(data: any) {
        this.configTrocas = { ...data };
    }

    @Mutation
    setConfigComercialGeral(data: any) {
        this.configComercialGeral = { ...data };
    }

    get getConfigComercialGeral(): ComercialGeralConfig {
        return this.configComercialGeral;
    }

    get getConfigTrocas(): any {
        return this.configTrocas;
    }

    get getConfigEstoque(): EstoqueConfig {
        return this.configEstoque;
    }

    get getConfigFinanceiro(): any {
        return this.configFinanceiro;
    }

    get getConfigLogistica(): any {
        return this.configLogistica;
    }

    get getLocalizacaoAtual(): any {
        return this.localizacaoAtual;
    }

    get getLinksRedesSociais(): any {
        return this.linksRedesSociais;
    }

    get getListaPaginasCustom(): Array<any> {
        return this.listaPaginasCustom.filter(el => el.situacao);
    }

    get getListaPaginasCustomAdmin(): Array<any> {
        return this.listaPaginasCustom;
    }

    get getConfigsVisuais(): any {
        return this.configsVisuais;
    }

    get getAplicativo(): any {
        return this.aplicativo;
    }

    get getListaBanners(): Array<any> {
        return this.listaBanners.filter(el => el.situacao).sort((a, b) => a?.ordem - b?.ordem);
    }

    get getListaBannersAdmin(): Array<any> {
        return this.listaBanners;
    }

    get getImagensBanner() {
        return this.getListaBanners.map((el) => {
            return {
                ...imageService.makeBannerImageURL(el.imagem),
                url: normalizeHttp(el.link),
            };
        });
    }
}

export default ConfigModule;